// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/radio.js';

import { paths } from '../generated/radio';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('radio', Original, paths);
